var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3422 11.4212C27.7457 5.52627 36.2543 5.52626 39.6578 11.4212L58.8021 44.5803C62.2056 50.4752 57.9513 57.8439 51.1444 57.8439H12.8556C6.04872 57.8439 1.7944 50.4752 5.19785 44.5803L24.3422 11.4212Z",
    fill: "#D12D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.013 26.6404L30.9006 39.112C31.1028 40.3254 32.6534 40.3254 32.8556 39.112L34.6758 26.6404C35.0129 21.7865 28.6759 21.7865 29.013 26.6404",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8444 47.0007C33.4081 47.0007 34.6758 45.733 34.6758 44.1693C34.6758 42.6055 33.4081 41.3379 31.8444 41.3379C30.2807 41.3379 29.013 42.6055 29.013 44.1693C29.013 45.733 30.2807 47.0007 31.8444 47.0007Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e115fa8aad20039ab5a609469a25e890.svg";
export { ForwardRef as ReactComponent };